import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import { PageHeader } from 'components/page-header'
import AvailabilityManager from './availability-manager'
import { gql, useQuery } from '@apollo/client'
import { get } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import OnboardingProgressSection from 'components/onboarding-progress'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'

export const COACH_ONBOARDING_STATUS = gql`
  query CoachOnboardingStatus {
    currentUser {
      attributes {
        ... on Coach {
          coachOnboardingProgress {
            coachProfileCreated
            schedulableCreated
            availabilityAdded
            facilityAdded
          }
        }
      }
    }
  }
`

const Availability = ({ coachOnboardingProgress, refetch }) => {
  const settingsStyles = useSettingsStyles()
  const { path } = useRouteMatch()

  const crumbs = [
    {
      label: 'Onboarding Dashboard',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]

  return (
    <>
      <PageHeader title="Availability" crumbs={crumbs} />
      <Box className={settingsStyles.contentContainer}>
        <OnboardingProgressSection
          coachOnboardingProgress={coachOnboardingProgress}
        />
        <AvailabilityManager
          refetchCoachOnboardingStatus={refetch}
          coachOnboardingProgress={coachOnboardingProgress}
        />
      </Box>
    </>
  )
}

const AvailabilityPage = () => {
  const { data, loading, error, refetch } = useQuery(COACH_ONBOARDING_STATUS)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error />

  const { coachOnboardingProgress } = get(data, 'currentUser.attributes')

  return (
    <Availability
      coachOnboardingProgress={coachOnboardingProgress}
      refetch={refetch}
    />
  )
}

export default AvailabilityPage
